import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTenant = (token, id) => {
    return fetch(`${apiUrl}tenants/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getTenant